"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cardTypeSchema = void 0;
var _api = require("@whitbread-eos/api");
var _zod = require("zod");
var cardTypeSchema = t => {
  var schema = _zod.z.object({
    cardType: _zod.z.string(),
    CNP: _zod.z.boolean(),
    memorableWord: _zod.z.string().optional()
  });
  var validation = (data, setError, clearErrors) => {
    if (data.cardType === _api.PAYMENT_TYPES.NEW_PIBA && data.CNP && !data.memorableWord) {
      setError('memorableWord', {
        type: 'manual',
        message: t('cards.centrallyStoredCard.card.memorableWord.required')
      });
      return false;
    }
    clearErrors('memorableWord');
    return true;
  };
  return {
    schema,
    validation
  };
};
exports.cardTypeSchema = cardTypeSchema;